import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectFullRow from '../project-full-row/ProjectFullRow';

class ProjectFullRows extends Component {
  static propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object),
    picUrlAttr: PropTypes.string.isRequired,
  };

  render() {
    const { projects, picUrlAttr } = this.props;

    const rows = projects.map(project => {
      return (
        <ProjectFullRow project={project} picUrlAttr={picUrlAttr} key={project.engName} />
      );
    });

    return (
      <section>{rows}</section>
    );
  }
}

export default ProjectFullRows;



// WEBPACK FOOTER //
// ./src/components/project-full-rows/ProjectFullRows.js